import { lazy } from 'react';
import { CalendarIcon } from '@chakra-ui/icons';

export const calendarsModuleConfig = {
  id: 'calendars',
  name: 'Calendars',
  icon: CalendarIcon,
  color: 'purple',
  description: 'Manage business calendars and events',
  path: '/calendars',
  routes: [
    {
      path: '/calendars',
      component: lazy(() => import('./CalendarsList')),
      exact: true,
      permissions: ['CALENDAR_VIEWER', 'CALENDAR_MANAGER', 'CALENDAR_ADMIN']
    },
    {
      path: '/calendars/new',
      component: lazy(() => import('./NewCalendar')),
      permissions: ['CALENDAR_MANAGER', 'CALENDAR_ADMIN']
    },
    {
      path: '/calendars/:id/edit',
      component: lazy(() => import('./EditCalendar')),
      permissions: ['CALENDAR_MANAGER', 'CALENDAR_ADMIN']
    },
    {
      path: '/calendars/:id',
      component: lazy(() => import('./CalendarDetails')),
      permissions: ['CALENDAR_VIEWER', 'CALENDAR_MANAGER', 'CALENDAR_ADMIN']
    }
  ],
  navigation: {
    main: {
      label: 'Calendars',
      icon: CalendarIcon,
      path: '/calendars',
      order: 15,
      permissions: ['CALENDAR_VIEWER', 'CALENDAR_MANAGER', 'CALENDAR_ADMIN']
    },
    sub: [
      {
        label: 'All Calendars',
        path: '/calendars',
        permissions: ['CALENDAR_VIEWER', 'CALENDAR_MANAGER', 'CALENDAR_ADMIN']
      },
      {
        label: 'New Calendar',
        path: '/calendars/new',
        permissions: ['CALENDAR_MANAGER', 'CALENDAR_ADMIN']
      }
    ]
  },
  permissions: {
    viewer: ['CALENDAR_VIEWER'],
    manager: ['CALENDAR_MANAGER'],
    admin: ['CALENDAR_ADMIN']
  },
  features: [
    'View calendars and events',
    'Create and manage calendars',
    'Schedule events with attendees',
    'Set up recurring events',
    'Export calendars as .ics files',
    'Share calendars with team members',
    'Integrate with email for calendar invites',
    'Link calendars to companies and employees'
  ],
  requiredTier: 'PROFESSIONAL'
};